function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import s from './Tag.scss';
import cx from 'classnames';
import { Heading, Text } from 'wix-style-react';

var Tag = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tag, _Component);

  function Tag(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "mouseEnterHandler", function () {
      _this.setState({
        tagState: 'hover'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "mouseLeaveHandler", function () {
      _this.setState({
        tagState: ''
      });
    });

    _this.state = {
      tagState: ''
    };
    return _this;
  }

  var _proto = Tag.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        tagDisplayName = _this$props.tagDisplayName,
        onTagClick = _this$props.onTagClick,
        isSelected = _this$props.isSelected,
        tagSelectedColor = _this$props.tagSelectedColor,
        dataAid = _this$props.dataAid,
        isMobile = _this$props.isMobile;
    var tagState = this.state.tagState;
    var style = {};

    if (isSelected) {
      style = {
        color: tagSelectedColor,
        borderColor: tagSelectedColor
      };
    } else if (tagState === 'hover') {
      style = {
        color: tagSelectedColor
      };
    }

    return /*#__PURE__*/React.createElement("button", {
      "data-aid": dataAid,
      onMouseEnter: this.mouseEnterHandler,
      onMouseLeave: this.mouseLeaveHandler,
      style: style,
      className: cx(s.tag, (_cx = {}, _cx[s.tagSelected] = isSelected, _cx)),
      onClick: onTagClick
    }, isMobile ? /*#__PURE__*/React.createElement(Text, {
      weight: "normal"
    }, tagDisplayName) : /*#__PURE__*/React.createElement(Heading, {
      appearance: "H3"
    }, tagDisplayName));
  };

  return Tag;
}(Component);

export default Tag;